import { IInMemoryRepo } from '../interfaces/memory'

export class InMemoryRepo<T> implements IInMemoryRepo<T> {
  private inMemory: Record<string, T>

  constructor() {
    this.inMemory = {}
  }

  getInMemory(id: string) {
    return this.inMemory[id] || null
  }

  setInMemory(id: string, item: T) {
    this.inMemory[id] = item

    return item
  }
}
